import { render, staticRenderFns } from "./CustomStatusBadge.vue?vue&type=template&id=7de39078&lang=pug&"
import script from "./CustomStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CustomStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./CustomStatusBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports